import React, { useEffect, useState } from 'react';
import { companyLogos } from '../data/mockData';

const quotes = [
  {
    text: "We have enough dashboards telling us what went wrong last quarter. Forsyt is the first tool I've seen that actually steps in to fix the behaviour before the deal is lost. It bridges the gap between data and execution.",
    author: "Chaitanya Kakkar",
    title: "Vice President - Business and International Expansion, SingleInterface"
  },
  {
    text: "The biggest challenge in revenue isn't knowing what to do, it's getting reps to consistently do it. The real-time nudges can completely change sales team's follow-through. It's like having a frontline manager guiding every deal.",
    author: "Aditya Ghosh",
    title: "Lead Product Manager, Techjockey"
  },
  {
    text: "Every revenue leader knows that deals slip because of a lack of follow-through, not a lack of forecasting data. Building a platform whose sole purpose is to drive those critical actions is a massive step forward for sales teams.",
    author: "Rajath KN",
    title: "Associate Director, Ex-IBM / Ex-Whatfix"
  }
];

const CompanyLogos = () => {
  const [activeQuote, setActiveQuote] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveQuote((prev) => (prev + 1) % quotes.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const row1Logos = companyLogos.filter((_, i) => i % 2 === 0);
  const row2Logos = companyLogos.filter((_, i) => i % 2 === 1);
  const allRow1 = [...row1Logos, ...row1Logos];
  const allRow2 = [...row2Logos, ...row2Logos];

  return (
    <section className="py-16 bg-white border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
            Trusted by modern revenue teams
          </p>
          <p className="text-xs text-gray-400">
            From SaaS to fintech to travel-tech, GTM leaders use Forsyt to move from dashboards to action engines.
          </p>
        </div>

        <div className="space-y-4 overflow-hidden">
          {/* First row - CSS animation scrolling left */}
          <div className="overflow-hidden">
            <div className="flex gap-4 items-center animate-scroll-left" style={{ width: 'max-content' }}>
              {allRow1.map((logo, index) => (
                <div
                  key={`row1-${index}`}
                  className="flex-shrink-0 w-20 h-12 sm:w-28 sm:h-16 rounded-lg overflow-hidden relative"
                >
                  <img
                    src={logo.image}
                    alt={logo.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    style={{ filter: 'blur(3px)' }}
                  />
                  <div className="absolute inset-0 bg-white/10" />
                </div>
              ))}
            </div>
          </div>

          {/* Second row - CSS animation scrolling right */}
          <div className="overflow-hidden">
            <div className="flex gap-4 items-center animate-scroll-right" style={{ width: 'max-content' }}>
              {allRow2.map((logo, index) => (
                <div
                  key={`row2-${index}`}
                  className="flex-shrink-0 w-20 h-12 sm:w-28 sm:h-16 rounded-lg overflow-hidden relative"
                >
                  <img
                    src={logo.image}
                    alt={logo.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    style={{ filter: 'blur(3px)' }}
                  />
                  <div className="absolute inset-0 bg-white/10" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Rotating Quotes */}
        <div className="mt-12 relative" data-testid="quote-carousel">
          <div className="max-w-2xl mx-auto text-center min-h-[140px] flex items-center justify-center">
            {quotes.map((quote, index) => (
              <div
                key={index}
                className={`absolute inset-0 flex flex-col items-center justify-center transition-all duration-700 ${
                  index === activeQuote ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none'
                }`}
              >
                <p className="text-sm text-gray-600 italic leading-relaxed mb-3">
                  "{quote.text}"
                </p>
                <p className="text-sm font-semibold text-gray-900">{quote.author}</p>
                <p className="text-xs text-gray-400">{quote.title}</p>
              </div>
            ))}
          </div>
          <div className="flex justify-center gap-2 mt-4">
            {quotes.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveQuote(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === activeQuote ? 'bg-blue-600 w-5' : 'bg-gray-300'
                }`}
                data-testid={`quote-dot-${index}`}
                aria-label={`Show quote ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyLogos;
